import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalService } from '@app/core/services/modal.service';
import { ToastService } from '@app/core/services/toast.service';
import { MeteringPointEstimationGroupService } from '@app/api/dmc';

@Component({
  selector: 'app-vee-meteringpoint-remove',
  imports: [
    TranslatePipe
  ],
  templateUrl: './vee-meteringpoint-remove.component.html',
  styleUrl: './vee-meteringpoint-remove.component.css'
})
export class VeeMeteringpointRemoveComponent {

  public elements: any[] = [];

  public estimationGroupId?: string;

  constructor(
    private readonly modalService: ModalService,
    private readonly toastService: ToastService,
    private readonly meteringPointEstimationService: MeteringPointEstimationGroupService,
  ) {
  }

  public submit(): void {
    if (this.elements.length > 0) {
      const data = this.elements.map((element) => ({
        meteringPointIdentification: element.meteringPointIdentification,
        estimationGroupId: this.estimationGroupId!
      }));

      this.meteringPointEstimationService.meteringPointEstimationGroupRemoveMeteringPointEstimationGroupPost(data).subscribe(
        (result) => {
          this.toastService.show('vee.meteringpoint.meteringpointremoved');
          this.modalService.close();
        }
      )
    }
  }

}
